import React from 'react';
import WatchlistHeader from './WatchlistHeader.jsx';
import WatchlistRow from './WatchlistRow.jsx';
import useAppStore from '../../store/useAppStore.js';
import useWatchlist from '../../hooks/useWatchlist.js';
import './WatchlistPanel.css';

export default function WatchlistPanel() {
  const { isLoading, error } = useWatchlist();
  const { selectedTicker, setSelectedTicker } = useAppStore();
  const getSortedTickers = useAppStore(state => state.getSortedTickers);

  const tickers = getSortedTickers();

  if (error) {
    return <div className="watchlist-error">Error: {error}</div>;
  }

  return (
    <div className="watchlist-panel">
      <WatchlistHeader />

      <div className="watchlist-body">
        {isLoading && tickers.length === 0 ? (
          <div className="watchlist-loading">Loading...</div>
        ) : (
          tickers.map(ticker => (
            <WatchlistRow
              key={ticker.ticker}
              ticker={ticker}
              isActive={selectedTicker === ticker.ticker}
              onClick={() => setSelectedTicker(ticker.ticker, ticker)}
            />
          ))
        )}
      </div>
    </div>
  );
}
